<template>
  <div>
    <b-container class="p-0">
      <approve-permission
        :orderId="selectedOrderID"
        :tab-no="order.TabNo"
        action-type="DeleteItem"
        @acceptPermission="openWithAcceptPermission"
        v-model="approveModal"
      />
      <b-row class="flex-grow-1 mt-3">
      <b-col cols="4">
        <b-btn
          variant="warning"
          block
          class="text-nowrap"
          :disabled="loadingBtn || disableEditButton || remainCount === '0' || hasCredit || errors.any()"
          @click="editItemFinaly"
        >
          <span v-if="loadingBtn">
            <font-awesome-icon spin icon="circle-notch" class="align-middle" />
          </span>
          <span v-else>Update item</span>
        </b-btn>
      </b-col>

      <b-col cols="4">
        <b-btn variant="danger" block class="text-nowrap cancel-btn-cmodal" :disabled="loadingBtn" @click="cancel">
          <span v-if="loadingBtn">
            <font-awesome-icon spin icon="circle-notch" class="align-middle" />
          </span>
          <span v-else>Cancel</span>
        </b-btn>
      </b-col>

      <b-col cols="4" v-if="itemLength.length > 1">
        <!--                {{disabledField}}-->
        <b-btn variant="danger" block class="text-nowrap" :disabled="loadingBtn || hasCredit" @click="openDeleteItem">
          <span v-if="loadingBtn">
            <font-awesome-icon spin icon="circle-notch" class="align-middle" />
          </span>
          <span v-else
            >Delete Item
            <span v-if="$showApprove([3, 4, 5, 11, 12])">*</span>
          </span>
        </b-btn>
      </b-col>
    </b-row>
      <b-row>
        <b-col cols="12">
          <div class="d-flex flex-row align-items-center justify-content-between">
            <div></div>
            <b-form-group class="text-md-center" label="">
              <b-form-radio-group
                @change="changeItemType"
                size="lg"
                :disabled="OrderType === 1 || OrderType === 0 ? true : true"
                id="radio-group-2"
                v-model="ItemType"
                name="radio-sub-component"
              >
                <b-form-radio class="mx-md-5" size="lg" value="Food">Food</b-form-radio>
                <b-form-radio class="mx-5" size="lg" value="Drink">Drink</b-form-radio>
              </b-form-radio-group>
            </b-form-group>

            <b-form-group>
              <b-form-checkbox id="checkbox-1" v-model="openItem" name="checkbox-1" value="open" unchecked-value="close" disabled>
                Open Item
              </b-form-checkbox>
            </b-form-group>
          </div>
        </b-col>
        <b-col cols="12" v-if="!isOpen">
          <div class=" overflow-auto">
            <b-button-group size="sm">
              <b-button
                style="font-size: 0.9rem"
                v-for="item in MenuTypeAl"
                class="py-4 px-3"
                :class="item.selected ? 'activeBtn' : 'deactiveBtn'"
                @click="GetRestaurantItems(item, item.MenuTypeID, ItemType)"
                :disabled="OrderType === 1 || OrderType === 0 ? true : true"
              >
                {{ item.MenuType }}
              </b-button>
            </b-button-group>
          </div>
        </b-col>
        <b-col cols="12" v-if="!isOpen">
          <div class="my-3 multiselect-availability">
            <Multiselect
              class="miniMulti"
              v-model="ItemCategory"
              :options="RestaurantItems"
              v-validate="'required'"
              name="item"
              @input="changeItemCategory"
              placeholder="search"
              :disabled="true"
            />
          </div>
        </b-col>
        <b-col cols="12" lg="6" class="my-1 my-lg-0" v-if="!isOpen">
          <div style="border: 1px solid #e4e7ea; border-radius: 4px" class="p-2 h-100">
            <b-form-group class="mt-0" label="" v-if="ItemCategory !== null">
              <b-form-radio-group
                stacked
                class="my-2"
                :disabled="OrderType === 0 || OrderType === 1 || OrderType === 3 ? true : false"
                v-validate="'required'"
                size="lg"
                id="radio-group-3"
                v-model="PriceType"
                name="Price"
              >
                <b-form-radio v-if="ItemCategory.Price >= 0" value="Price">
                  <span class="text-dark font-weight-bold" v-if="ItemCategory.PriceComment.trim().length">{{
                    ItemCategory.PriceComment
                  }}</span>
                  <span class="ml-3 text-muted"
                    >${{ ItemCategory.Price }}
                    <span v-if="ItemCategory.Price === 0" class="mx-2">
                      (FREE)
                    </span>
                  </span>
                </b-form-radio>
                <b-form-radio v-if="ItemCategory.Price1 >= 0" value="Price1">
                  <span class="text-dark font-weight-bold" v-if="ItemCategory.Price1Comment.trim().length">{{
                    ItemCategory.Price1Comment
                  }}</span>
                  <span class="ml-3 text-muted"
                    >${{ ItemCategory.Price1 }}
                    <span v-if="ItemCategory.Price1 === 0" class="mx-2">
                      (FREE)
                    </span>
                  </span>
                </b-form-radio>
                <b-form-radio v-if="ItemCategory.Price2 >= 0" value="Price2">
                  <span class="text-dark font-weight-bold" v-if="ItemCategory.Price2Comment.trim().length">{{
                    ItemCategory.Price2Comment
                  }}</span>
                  <span class="ml-3 text-muted"
                    >${{ ItemCategory.Price2 }}
                    <span v-if="ItemCategory.Price2 === 0" class="mx-2">
                      (FREE)
                    </span>
                  </span>
                </b-form-radio>
                <b-form-radio v-if="ItemCategory.Price3 >= 0" value="Price3">
                  <span class="text-dark font-weight-bold" v-if="ItemCategory.Price3Comment.trim().length">{{
                    ItemCategory.Price3Comment
                  }}</span>
                  <span class="ml-3 text-muted"
                    >${{ ItemCategory.Price3 }}
                    <span v-if="ItemCategory.Price3 === 0" class="mx-2">
                      (FREE)
                    </span>
                  </span>
                </b-form-radio>
                <b-form-radio v-if="ItemCategory.Price4 >= 0" value="Price4">
                  <span class="text-dark font-weight-bold" v-if="ItemCategory.Price4Comment.trim().length">{{
                    ItemCategory.Price4Comment
                  }}</span>
                  <span class="ml-3 text-muted"
                    >${{ ItemCategory.Price4 }}
                    <span v-if="ItemCategory.Price4 === 0" class="mx-2">
                      (FREE)
                    </span>
                  </span>
                </b-form-radio>
              </b-form-radio-group>
            </b-form-group>
            <div v-if="alcoholic" class="h5 font-weight-bold mb-0" style="color: #4748cc">
              * Alcoholic: VERIFY AGE *
            </div>
          </div>
        </b-col>
        <b-col cols="12" lg="6" class="my-1 my-lg-0" v-if="!isOpen">
          <div
            v-if="modifierCategories.length"
            class="overflow-auto p-2 h-100"
            style="border: 1px solid #e4e7ea; border-radius: 4px"
          >
            <h5 v-if="modifierCategories.length" class="font-weight-bold mb-0">Modifiers</h5>
            <b-button-group size="md">
              <b-button
                v-for="item in modifierCategories"
                :class="{
                  activeBtn: item.selected,
                  deactiveBtn: !item.selected
                }"
                @click="selectModifier(item)"
              >
                <span :class="!item.selected && item.hasError ? 'error-btn-animated' : 'text-dark'">
                  {{ item.ModifierCategory }}
                </span>
              </b-button>
            </b-button-group>
            <div>
              <p class="my-2">
                <span style="color: rgba(0,0,71,0.82)">
                  <span v-if="showSelectedModifier.IsOptional">Optional</span>
                  <span v-else>Required</span>
                </span>
                <span style="color: rgba(0,0,71,0.82)">
                  <span>{{ ' ( ' + showSelectedModifier.ChoiceOption + '  ' + showSelectedModifier.ChoiceNumber + ' ) ' }}</span>
                </span>
              </p>
              <p class="text-danger font-weight-bold">
                {{ showSelectedModifier.errorText }}
              </p>
              <div>
                <p v-for="item in showSelectedModifier.ModifierItems">
                  <b-form-checkbox
                    :disabled="OrderType === 1 || OrderType === 0 || OrderType === 3 ? true : false"
                    v-model="item.checked"
                    name="check-button"
                    @change="changeModifierOption(item, showSelectedModifier)"
                  >
                    <span>{{ item.ModifierName }}</span>
                    <span v-if="item.ModifierDesc !== ''">{{ ' - ' }}</span>
                    <span style="font-style: italic" v-if="item.ModifierDesc !== ''">{{ item.ModifierDesc }}</span>
                    <span class="mx-3" v-if="item.itemPrice !== '' || item.itemPrice !== null">{{
                      '+$' + item.Price.toFixed(2)
                    }}</span>
                  </b-form-checkbox>
                </p>
              </div>
            </div>
          </div>
        </b-col>
        <b-col cols="12" lg="6" v-if="isOpen">
          <b-form-group>
            <b-input-group class="mx-1" prepend="Description">
              <b-input disabled readonly v-model="currentItemName" />
            </b-input-group>
          </b-form-group>

          <b-form-group v-if="showPrinterField">
            <b-input-group prepend="Printstation">
              <b-select
                v-model="PrinterID"
                :options="printers"
                text-field="PrinterName"
                value-field="PrinterID"
                name="Printstation"
              />
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col cols="12" lg="6" v-if="isOpen">
          <b-form-group>
            <b-input-group prepend="Unit Price($)">
              <numeric-input no-seprator v-model="openItemUnitPrice" v-validate="'required'" name="unit price" />
            </b-input-group>
          </b-form-group>

          <b-form-group>
            <b-input-group prepend="Display station">
              <b-select v-model="KDS" :options="kdsList" v-validate="'required'" name="Display station" />
            </b-input-group>
          </b-form-group>
        </b-col>

        <b-col cols="12" lg="6" class="mt-3">
          <div v-if="hasCourse && OrderType === 2" class="d-flex align-items-center mb-3 flex-nowrap">
            <b-btn :disabled="OrderStatus === 4" size="sm" variant="danger" @click="reduceCourse">
              <font-awesome-icon icon="minus" class="mx-1 align-middle" />
            </b-btn>
            <b-input-group class="mx-1" prepend="Course">
              <numeric-input :disabled="OrderStatus === 4" no-seprator :decimal="false" v-model="CourseNo" name="Course" />
            </b-input-group>
            <b-btn size="sm" :disabled="OrderStatus === 4" variant="danger" @click="addCourse">
              <font-awesome-icon icon="plus" class="mx-1 align-middle" />
            </b-btn>
          </div>

          <div class="d-flex align-items-center flex-nowrap mb-3 mt-3">
            <b-btn
              v-if="!disabledField"
              size="sm"
              variant="danger"
              @click="Quantity = Quantity - 1"
              :disabled="OrderType === 0 || OrderType === 1 || OrderType === 3 ? true : false"
            >
              <font-awesome-icon icon="minus" class="mx-1 align-middle" />
            </b-btn>
            <b-input-group class="mx-1" prepend="Quantity">
              <numeric-input
                no-seprator
                :decimal="false"
                v-model="Quantity"
                v-validate="quantityValidation"
                name="quantity"
                :disabled="OrderType === 0 || OrderType === 1 || OrderType === 3 || disabledField ? true : false"
              />
            </b-input-group>
            <b-btn
              v-if="!disabledField"
              size="sm"
              variant="danger"
              @click="Quantity = Quantity + 1"
              :disabled="OrderType === 0 || OrderType === 1 || OrderType === 3 ? true : false"
            >
              <font-awesome-icon icon="plus" class="mx-1 align-middle" />
            </b-btn>
          </div>
          <div v-if="!isOpen">
            <p class="mb-0 text-danger font-weight-bold" v-if="remainCount !== ''">Only {{ remainCount }} Left</p>
            <p v-if="modifierValidation" class="font-weight-bold mt-3 text-danger">
              Please select the missing modifier(s).
            </p>
          </div>
        </b-col>
        <b-col cols="12" lg="6">
          <b-input-group prepend="Special Instructions *" class="my-3">
            <b-textarea v-model="Description" v-validate="'max:150'" name="Special Instructions" />
          </b-input-group>
          <p class="mt-1 text-danger" style="font-style: italic">
            * Text input will be visible to customers.
          </p>
        </b-col>
        <b-col cols="12">
          <b-alert :show="errors.any()" variant="danger" class="px-4 my-2">
            <ul class="m-0 px-1">
              <li v-for="err in errors.all()" :key="err">{{ err }}</li>
            </ul>
          </b-alert>
        </b-col>
      </b-row>
    </b-container>

    <b-row class="flex-grow-1 mt-3">
      <b-col cols="4">
        <b-btn
          variant="warning"
          block
          class="text-nowrap"
          :disabled="loadingBtn || disableEditButton || remainCount === '0' || hasCredit || errors.any()"
          @click="editItemFinaly"
        >
          <span v-if="loadingBtn">
            <font-awesome-icon spin icon="circle-notch" class="align-middle" />
          </span>
          <span v-else>Update item</span>
        </b-btn>
      </b-col>

      <b-col cols="4">
        <b-btn variant="danger" block class="text-nowrap cancel-btn-cmodal" :disabled="loadingBtn" @click="cancel">
          <span v-if="loadingBtn">
            <font-awesome-icon spin icon="circle-notch" class="align-middle" />
          </span>
          <span v-else>Cancel</span>
        </b-btn>
      </b-col>

      <b-col cols="4" v-if="itemLength.length > 1">
        <!--                {{disabledField}}-->
        <b-btn variant="danger" block class="text-nowrap" :disabled="loadingBtn || hasCredit" @click="openDeleteItem">
          <span v-if="loadingBtn">
            <font-awesome-icon spin icon="circle-notch" class="align-middle" />
          </span>
          <span v-else
            >Delete Item
            <span v-if="$showApprove([3, 4, 5, 11, 12])">*</span>
          </span>
        </b-btn>
      </b-col>
    </b-row>

    <div v-if="order.Credit" class="mt-4">
      <span class="text-danger font-weight-bold">
        Please remove applied credit first to edit or delete this item
      </span>
    </div>

    <c-modal v-model="confirmationDeleteModal" :tag="false" hide-header hide-footer title="Delete Item" centered size="md">
      <template>
        <div>
          <p>Do you want to delete this item?</p>
        </div>
        <b-row class="flex-grow-1 mt-3">
          <b-col cols="6">
            <b-btn variant="warning" block @click="deleteItem">
              YES, Proceed with delete
            </b-btn>
          </b-col>

          <b-col cols="6">
            <b-btn block variant="danger" class="cancel-btn-cmodal" @click="confirmationDeleteModal = !confirmationDeleteModal"
              >No, Never mind</b-btn
            >
          </b-col>
        </b-row>
      </template>
    </c-modal>
  </div>
</template>

<script>
import Multiselect from '../shared/multiselect'
import NumericInput from '../shared/NumericInput'
import ApprovePermission from '../shared/approvePermission'
import CModal from '../shared/Cmodal'
export default {
  name: 'editItem',
  components: {
    CModal,
    ApprovePermission,
    Multiselect,
    NumericInput
  },
  props: {
    OrderType: {
      required: true
    },
    selectedOrderID: {
      required: true
    },
    OrderDetailID: {
      required: true
    },
    loadingBtn: {
      required: true
    },
    itemLength: {
      required: true
    },
    CheckDiff: {required: false},
    currentItemPrice: {required: false},
    order: {required: true, type: Object},
    disabledField: {
      required: false
    },
    hasCourse: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      CourseNo: '',
      approveModal: false,
      showErrorPrice: false,
      confirmationDeleteModal: false,
      ItemType: 'Food',
      Quantity: null,
      MenuTypeAl: [],
      currentMenuTypeID: null,
      RestaurantItems: [],
      Description: null,
      currentItemName: null,
      DrinkID: null,
      FoodId: null,
      currentPriceType: null,
      PriceType: '',
      ItemID: null,
      ItemCategory: null,
      modifierCategories: [],
      currentModifiers: '',
      remainCount: '',
      openItem: 'open',
      openItemUnitPrice: null,
      alcoholic: false,
      originQuantity: null,
      OrderStatus: null,
      KDS: '',
      PrinterID: 0,
      printers: [],
      kdsList: []
    }
  },
  mounted() {
    //get current details selected item
    //Fill in the displayed fields by default
    Promise.all([
      this.getCurrentDetails(this.selectedOrderID, this.OrderDetailID),
      this.GetOrderDetailKDSPrinter(this.selectedOrderID, this.OrderDetailID)
    ]).then(res => {
      let detail = res[0].results.orderDetail
      if (detail.CourseNo) {
        this.CourseNo = detail.CourseNo.split('C')[1]
      } else {
        this.CourseNo = ''
      }
      this.Quantity = detail.Quantity
      this.OrderStatus = detail.OrderStatus
      this.originQuantity = detail.Quantity
      this.currentMenuTypeID = detail.currentMenuTypeID
      this.Description = detail.Description
      this.alcoholic = res[0].results.orderDetail.Alcoholic
      this.currentItemName = detail.ItemName
      if (this.currentItemName.includes('Food Item') || this.currentItemName.includes('Drink Item')) {
        this.openItem = 'open'
        this.openItemUnitPrice = detail.currentPriceType
      } else {
        this.openItem = 'close'
      }
      this.FoodId = detail.FoodID
      this.DrinkID = detail.DrinkID
      this.currentPriceType = detail.currentPriceType
      this.PriceType = this.currentPriceType
      this.modifierCategories = res[0].results.modifierCategories
      this.currentModifiers = detail.Modifiers
      let arrayOfCurrentModifiers = detail.Modifiers.split(',')
      this.modifierCategories.forEach((item, index) => {
        this.$set(item, 'hasError', false)
        item.errorText = ''
        if (index === 0) {
          this.$set(item, 'selected', true)
        } else {
          this.$set(item, 'selected', false)
        }
        item.ModifierItems.forEach(ch => {
          ch.value = ch.ModifierID
          ch.text = ch.ModifierName
          let find = arrayOfCurrentModifiers.find(i => i.trim() === ch.ModifierName)
          if (find) {
            this.$set(ch, 'checked', true)
          } else {
            this.$set(ch, 'checked', false)
          }
        })
      })
      if (detail.DrinkID === 0) {
        this.ItemType = 'Food'
        this.ItemID = detail.FoodID
        this.getItemAvailabilty(this.ItemID)
      } else {
        this.ItemType = 'Drink'
        this.ItemID = detail.DrinkID
        this.getItemAvailabilty(this.ItemID)
      }
      let model = {
        RestaurantID: this.$store.state.selectedRestaurantId,
        // UserID: localStorage.getItem('userID'),
        ItemType: this.ItemType
      }
      this.$api.getRestaurant.GetRestaurantMenuTypes(model).then(res => {
        if (res.success) {
          this.MenuTypeAl = res.results.RestaurantMenuTypeAll.filter(item => item.CanMenuTypeBeShown)
          this.MenuTypeAl.forEach(item => {
            this.$set(item, 'selected', false)
            if (+item.MenuTypeID === +this.currentMenuTypeID) {
              item.selected = true
            }
          })
          let object = {
            RestaurantID: this.$store.state.selectedRestaurantId,
            // UserID: localStorage.getItem('userID'),
            ItemType: this.ItemType,
            MenuTypeID: this.currentMenuTypeID
          }
          this.$api.getRestaurant.GetRestaurantItems(object).then(res => {
            if (res.success) {
              let result = res.results.RestaurantItems
              result.forEach(item => {
                item.value = item.ItemID

                item.availablePrices = [
                  {text: 'Price', value: item.Price},
                  {text: 'Price1', value: item.Price1},
                  {text: 'Price2', value: item.Price2},
                  {text: 'Price3', value: item.Price3},
                  {text: 'Price4', value: item.Price4}
                ]
                if (item.availablePrices.filter(i => i.value >= 0).length > 1) {
                  item.priceSymbol = ' + '
                } else {
                  item.priceSymbol = ''
                }
                if (item.HasModifier) {
                  item.priceSymbol = ' + '
                }
                if (item.Price !== -999999) {
                  item.name = item.ItemCategory + ' - ' + item.ItemName + ' - ' + '$' + item.Price + item.priceSymbol
                } else {
                  item.name = item.ItemCategory + ' - ' + item.ItemName + ' ' + item.priceSymbol
                }
              })
              this.RestaurantItems = result

              let find = this.RestaurantItems.find(i => +i.ItemID === +this.ItemID)
              if (find) {
                this.ItemCategory = find
              }
            } else {
              this.$showError(res.message)
            }
          })
        } else {
          this.$showError(res.message)
        }
      })
    })
  },
  computed: {
    showPrinterField() {
      return this.printers.length === 1 ? false : true
    },
    isOpen() {
      return this.openItem === 'open'
    },
    showSelectedModifier() {
      return this.modifierCategories.find(item => item.selected)
    },
    disableEditButton() {
      if (!this.modifierCategories.length) {
        return false
      } else {
        return this.modifierCategories.some(i => i.hasError)
      }
    },
    hasCredit() {
      return !!this.order.Credit
    },
    quantityValidation() {
      if (this.remainCount === '') {
        return {
          required: true,
          min_value: 1
        }
      } else if (this.remainCount == '0') {
        return {}
      } else {
        return {
          required: true,
          max_value: this.remainCount,
          min_value: 1
        }
      }
    }
  },

  methods: {
    reduceCourse() {
      if (this.CourseNo >= 1) {
        this.CourseNo = this.CourseNo - 1
        if (this.CourseNo === 0) {
          this.CourseNo = ''
        }
      }
    },
    addCourse() {
      if (this.CourseNo === '') {
        this.CourseNo = 1
      } else {
        this.CourseNo = this.CourseNo + 1
      }
    },
    openDeleteItem() {
      if (this.$showApprove([3, 4, 5, 11, 12])) {
        this.approveModal = true
      } else {
        this.confirmationDeleteModal = true
      }
    },
    openWithAcceptPermission() {
      this.approveModal = false
      this.confirmationDeleteModal = true
    },
    getItemAvailabilty(ItemID) {
      const model = {
        // UserID: localStorage.getItem('userID'),
        RestaurantID: this.$store.state.selectedRestaurantId,
        ItemType: this.ItemType,
        ItemID
      }
      this.$api.getRestaurant.GetItemAvailability(model).then(res => {
        if (res.success) {
          let results = res.results
          if (results.Total_Remain) {
            if (results.Total_Remain < 0) {
              this.remainCount = '0'
            } else {
              this.remainCount = results.Total_Remain
            }
          } else {
            this.remainCount = ''
          }
          // if (results.Total_Remain && +results.Total_Remain < 0) {
          //     this.remainCount = '0'
          // } else {
          //     this.remainCount = results.Total_Remain
          // }
        } else {
        }
      })
    },
    selectModifier(modifier) {
      this.modifierCategories.forEach(item => {
        item.selected = false
      })
      modifier.selected = true
    },
    changeModifierOption(modifier, modifierGroup) {
      modifier.checked = !modifier.checked
      if (!modifierGroup.IsOptional) {
        //check at lease one modifier options
        let ChoiceNumber = modifierGroup.ChoiceNumber
        let ChoiceOption = modifierGroup.ChoiceOption
        if (ChoiceOption === 'Exactly') {
          let checkModifier = modifierGroup.ModifierItems.filter(i => i.checked)
          if (!checkModifier.length) {
            modifierGroup.errorText = 'Please select exactly ' + ChoiceNumber + ' items'
            modifierGroup.hasError = true
          } else {
            if (checkModifier.length !== +ChoiceNumber) {
              modifierGroup.errorText = 'Please select exactly ' + ChoiceNumber + ' items'
              modifierGroup.hasError = true
            } else {
              modifierGroup.errorText = ''
              modifierGroup.hasError = false
            }
          }
        } else if (ChoiceOption === 'Minimum') {
          let checkModifier = modifierGroup.ModifierItems.filter(i => i.checked)
          if (!checkModifier.length) {
            modifierGroup.errorText = 'Please select Mininmum ' + ChoiceNumber + ' choices'
            modifierGroup.hasError = true
          } else {
            if (checkModifier.length < +ChoiceNumber) {
              modifierGroup.errorText = 'Please select Mininmum ' + ChoiceNumber + ' choices'
              modifierGroup.hasError = true
            } else {
              modifierGroup.errorText = ''
              modifierGroup.hasError = false
            }
          }
        } else if (ChoiceOption === 'Maximum') {
          let checkModifier = modifierGroup.ModifierItems.filter(i => i.checked)
          if (!checkModifier.length) {
            modifierGroup.errorText = 'Please select Maximum ' + ChoiceNumber + ' choices'
            modifierGroup.hasError = true
          } else {
            if (checkModifier.length > +ChoiceNumber) {
              modifierGroup.errorText = 'Please select Maximum ' + ChoiceNumber + ' choices'
              modifierGroup.hasError = true
            } else {
              modifierGroup.errorText = ''
              modifierGroup.hasError = false
            }
          }
        }
      } else {
        let ChoiceNumber = modifierGroup.ChoiceNumber
        let ChoiceOption = modifierGroup.ChoiceOption
        if (ChoiceOption === 'Exactly') {
          let checkModifier = modifierGroup.ModifierItems.filter(i => i.checked)
          if (!checkModifier.length) {
            modifierGroup.errorText = ''
            modifierGroup.hasError = false
          } else {
            if (checkModifier.length !== +ChoiceNumber) {
              modifierGroup.errorText = 'Please select exactly ' + ChoiceNumber + ' items'
              modifierGroup.hasError = true
            } else {
              modifierGroup.errorText = ''
              modifierGroup.hasError = false
            }
          }
        } else if (ChoiceOption === 'Minimum') {
          let checkModifier = modifierGroup.ModifierItems.filter(i => i.checked)
          if (!checkModifier.length) {
            modifierGroup.errorText = ''
            modifierGroup.hasError = false
          } else {
            if (checkModifier.length < +ChoiceNumber) {
              modifierGroup.errorText = 'Please select Mininmum ' + ChoiceNumber + ' choices'
              modifierGroup.hasError = true
            } else {
              modifierGroup.errorText = ''
              modifierGroup.hasError = false
            }
          }
        } else if (ChoiceOption === 'Maximum') {
          let checkModifier = modifierGroup.ModifierItems.filter(i => i.checked)
          if (!checkModifier.length) {
            modifierGroup.errorText = ''
            modifierGroup.hasError = false
          } else {
            if (checkModifier.length > +ChoiceNumber) {
              modifierGroup.errorText = 'Please select Maximum ' + ChoiceNumber + ' choices'
              modifierGroup.hasError = true
            } else {
              modifierGroup.errorText = ''
              modifierGroup.hasError = false
            }
          }
        }
      }
    },
    changeItemType(value) {
      //filter menu types by two value - drink or food
      this.GetRestaurantMenuTypes(value)
    },
    getCurrentDetails(OrderID, OrderDetailID) {
      let model = {
        RestaurantID: this.$store.state.selectedRestaurantId,
        // UserID: localStorage.getItem('userID'),
        OrderID,
        OrderDetailID
      }
      return this.$api.getRestaurant.GetRestaurantCurrentOrderDetail(model).then(res => {
        if (res.success) {
          return res
        } else {
          this.$showError(res.message)
        }
      })
    },
    GetOrderDetailKDSPrinter(OrderID, OrderDetailID) {
      let model = {
        RestaurantID: this.$store.state.selectedRestaurantId,
        // UserID: localStorage.getItem('userID'),
        OrderID,
        OrderDetailID
      }
      return this.$api.getRestaurant.GetOrderDetailKDSPrinter(model).then(res => {
        if (res.success) {
          Promise.all([
            this.GetRestaurantKDSs(
              {
                RestaurantID: this.$store.state.selectedRestaurantId,
                // UserID: localStorage.getItem('userID')
              },
              res.OrderKDSPrinterDetail
            ),
            this.getPrinters(
              {
                RestaurantID: this.$store.state.selectedRestaurantId,
                // UserID: localStorage.getItem('userID')
              },
              res.OrderKDSPrinterDetail
            )
          ]).then(res => {})
        } else {
          this.$showError(res.message)
        }
      })
    },

    GetRestaurantKDSs(object, value) {
      return this.$api.getRestaurant.GetRestaurantKDSs(object).then(res => {
        if (res.success) {
          res.results.RestaurantKDS.forEach(item => {
            item.value = item.KDSID
            item.text = item.KDS
          })
          const list = res.results.RestaurantKDS
          this.kdsList = list
          const findKds = list.find(item => item.value == value.KDS)
          if (findKds) {
            this.KDS = findKds.KDSID
          }
        }
      })
    },
    getPrinters(object, value) {
      this.$api.getRestaurant.GetRestaurantPrinters(object).then(res => {
        if (res.success) {
          this.printers = [{PrinterName: 'None', PrinterID: 0}].concat(
            res.results.RestaurantPrinter.filter(i => i.PrintTaskID !== 2)
          )
          const findPrinter = this.printers.find(item => item.PrinterID == value.PrinterID)
          if (findPrinter) {
            this.PrinterID = findPrinter.PrinterID
          }
        }
      })
    },

    GetRestaurantMenuTypes(ItemType) {
      let model = {
        RestaurantID: this.$store.state.selectedRestaurantId,
        // UserID: localStorage.getItem('userID'),
        ItemType
      }
      this.$api.getRestaurant.GetRestaurantMenuTypes(model).then(res => {
        if (res.success) {
          this.RestaurantItems = []
          this.ItemCategory = null
          this.ItemID = null
          this.PriceType = null
          this.MenuTypeAl = res.results.RestaurantMenuTypeAll.filter(item => item.CanMenuTypeBeShown)
          this.MenuTypeAl.forEach(item => {
            this.$set(item, 'selected', false)
          })
        } else {
          this.$showError(res.message)
        }
      })
    },
    GetRestaurantItems(item, MenuTypeID, ItemType) {
      //get restaurant items by selected menutype and item type
      this.MenuTypeAl.forEach(i => {
        i.selected = false
      })
      item.selected = true
      let model = {
        RestaurantID: this.$store.state.selectedRestaurantId,
        // UserID: localStorage.getItem('userID'),
        ItemType,
        MenuTypeID
      }
      this.$api.getRestaurant.GetRestaurantItems(model).then(res => {
        if (res.success) {
          this.ItemCategory = null
          this.ItemID = null
          this.PriceType = null
          let result = res.results.RestaurantItems

          result.forEach(item => {
            item.availablePrices = [
              {text: 'Price', value: item.Price},
              {text: 'Price1', value: item.Price1},
              {text: 'Price2', value: item.Price2},
              {text: 'Price3', value: item.Price3},
              {text: 'Price4', value: item.Price4}
            ]
            if (item.availablePrices.filter(i => i.value >= 0).length > 1) {
              item.priceSymbol = ' + '
            } else {
              item.priceSymbol = ''
            }
            if (item.HasModifier) {
              item.priceSymbol = ' + '
            }
            item.value = item.ItemID
            item.name = item.ItemCategory + ' - ' + item.ItemName + ' - ' + '$' + item.Price + item.priceSymbol
          })
          this.RestaurantItems = result
          let find = this.RestaurantItems.find(i => +i.ItemID === +this.ItemID)
          if (find) {
            this.ItemCategory = find
          }
        } else {
          this.$showError(res.message)
        }
      })
    },
    deleteItem() {
      //delete item
      if (this.currentItemPrice > this.CheckDiff) {
        this.showErrorPrice = true
        this.confirmationDeleteModal = false
      } else {
        this.showErrorPrice = false
        this.confirmationDeleteModal = false
        this.$emit('deleteItem', this.OrderDetailID)
      }
    },
    cancel() {
      //close pop up
      this.$emit('cancelEditItem', false)
    },
    editItemFinaly() {
      //edit item
      this.$validator.validateAll().then(res => {
        if (res) {
          let ModifierIDs = []
          this.modifierCategories.forEach(item => {
            item.ModifierItems.forEach(ch => {
              if (ch.checked) {
                ModifierIDs.push(ch.ModifierID)
              }
            })
          })
          let object = {}
          if (this.openItem === 'open') {
            object = {
              IKey: this.OrderDetailID,
              RestaurantID: this.$store.state.selectedRestaurantId,
              // UserID: localStorage.getItem('userID'),
              OrderID: this.selectedOrderID,
              FoodId: this.ItemType === 'Food' ? this.ItemID : 0,
              DrinkID: this.ItemType === 'Drink' ? this.ItemID : 0,
              Qty: this.Quantity,
              PriceType: this.openItemUnitPrice,
              DetailDescription: this.Description,
              ModifierCategories: '',
              ModifierIDs: '',
              CourseNo: this.OrderType === 2 && this.CourseNo ? 'C' + this.CourseNo : '',
              OrderStatus: this.OrderStatus,
              open: true,
              KDS: this.KDS,
              PrinterID: this.PrinterID
            }
          } else {
            object = {
              IKey: this.OrderDetailID,
              RestaurantID: this.$store.state.selectedRestaurantId,
              // UserID: localStorage.getItem('userID'),
              OrderID: this.selectedOrderID,
              FoodId: this.ItemType === 'Food' ? this.ItemID : 0,
              DrinkID: this.ItemType === 'Drink' ? this.ItemID : 0,
              Qty: this.Quantity,
              PriceType: this.PriceType,
              DetailDescription: this.Description,
              ModifierCategories: this.modifierCategories,
              ModifierIDs: ModifierIDs.length ? '#' + ModifierIDs.join('#') : '',
              CourseNo: this.OrderType === 2 && this.CourseNo ? 'C' + this.CourseNo : '',
              OrderStatus: this.OrderStatus,
              open: false,
              KDS: '',
              PrinterID: ''
            }
          }

          if (this.originQuantity > this.Quantity) {
            if (this.$showApprove([3, 4, 5, 11, 12])) {
              this.approveModal = true
            } else {
              this.$emit('editItemFinaly', object)
            }
          } else {
            this.$emit('editItemFinaly', object)
          }
        }
      })
    },
    changeItemCategory(newVal) {
      let find = this.RestaurantItems.find(i => +i.ItemID === +newVal.ItemID)
      if (find) {
        this.ItemID = newVal.ItemID
        let getFirstPrice = find.availablePrices.filter(i => i.value >= 0)
        if (getFirstPrice.length) {
          this.PriceType = getFirstPrice[0].text
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
.activeBtn {
  background: #f5c31d !important;
  border-color: #c8ced3 !important;
}
.deactiveBtn {
  background: #fff !important;
  border-color: #959a9f !important;
  color: #959a9f !important;
}
select {
  option {
    span#itemName {
      font-weight: bold !important;
      color: red !important;
    }
  }
}
.error-btn-animated {
  animation: color 1s infinite;
  animation-fill-mode: forwards;
}

@keyframes color {
  from {
    color: #fff;
  }
  to {
    color: #000;
  }
}
</style>
